"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _es_ES = _interopRequireDefault(require("../../date-picker/locale/es_ES"));
var _default = exports["default"] = _es_ES["default"];